export enum AnimalClass {
    DOG = 1,
    CAT = 2,
    BIRD = 3,
    MAMMAL = 58,
}
